import React from 'react';
export function HeroSection() {
  return <section className="relative pt-6 pb-8 md:pt-24 md:pb-28 overflow-hidden px-4 sm:px-6 lg:px-8" style={{
    contain: 'layout style'
  }} data-id="element-124">
      {/* Background glow — hidden on mobile to reduce GPU compositing */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-purple-600/10 blur-[80px] md:blur-[120px] rounded-full pointer-events-none hidden md:block md:max-w-5xl md:h-[700px] md:bg-purple-600/15" data-id="element-125" />
      <div className="absolute top-40 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-blue-600/10 blur-[100px] rounded-full pointer-events-none hidden md:block" data-id="element-126" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-127">
        {/* Brand Tag */}
        <div className="hero-animate-1 inline-flex items-center gap-2 px-4 py-1.5 md:px-5 md:py-2 rounded-full bg-purple-500/10 border border-purple-500/30 text-purple-300 font-semibold text-xs md:text-sm tracking-widest mb-4 md:mb-8 uppercase shadow-[0_0_15px_rgba(168,85,247,0.15)]" data-id="element-128">
          👨‍👩‍👧‍👦 PACK 100 CITAS
        </div>

        {/* Main Headline */}
        <h1 className="hero-animate-2 text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.08] tracking-tight mb-4 md:mb-6 text-white" data-id="element-129">
          Menos pantallas, más abrazos:{' '}
          <span className="text-gradient-cosmic block mt-2" data-id="element-130">
            descubrí el poder del Pack 100 Citas
          </span>
        </h1>

        {/* Tagline */}
        <p className="hero-animate-2 text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-purple-400 mb-6 md:mb-12" data-id="element-131">
          Jugá. Conectá. Recordá.
        </p>

        {/* Product Image */}
        <div className="relative max-w-xs md:max-w-2xl mx-auto mb-6 md:mb-12" data-id="element-132">
          {/* Glow behind image — hidden on mobile for GPU savings */}
          <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/15 via-blue-500/10 to-gold-500/5 blur-2xl md:blur-3xl rounded-full scale-110 hidden md:block" data-id="element-133" />
          <img src="https://cdn.magicpatterns.com/uploads/cup8nvYsqX6U3HDxFAxEAw/mocap_final_100_citas-removebg-preview.webp" alt="MegaPack 100 Citas Familiares" className="relative z-10 w-full max-w-[540px] mx-auto h-auto drop-shadow-lg md:drop-shadow-2xl object-contain" width={1080} height={1080} sizes="(max-width: 480px) 280px, (max-width: 768px) 320px, 540px" loading="eager" decoding="async" fetchPriority="high" data-id="element-134" />
        </div>

        {/* Product Description */}
        <div className="hero-animate-3 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-135">
          <h2 className="text-base md:text-2xl font-bold text-purple-300 mb-2 md:mb-3 leading-relaxed" data-id="element-136">
            El sistema de conexión familiar que usan más de 500 familias
            latinoamericanas para crear recuerdos que duran toda la vida — en
            menos de 20 minutos por día.
          </h2>
        </div>

        {/* Trust Badges */}
        <div className="hero-animate-4 flex flex-wrap items-center justify-center gap-1.5 md:gap-3 mb-6 md:mb-10" data-id="element-137">
          {[{
          emoji: '📚',
          label: '4 Libros digitales'
        }, {
          emoji: '⚡',
          label: 'Descarga inmediata'
        }, {
          emoji: '🎁',
          label: '7 Bonos incluidos'
        }, {
          emoji: '💫',
          label: '+500 ideas'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-navy-800 border border-navy-700 text-xs md:text-sm font-medium text-slate-300" data-id="element-138">
              <span data-id="element-139">{badge.emoji}</span>
              {badge.label}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="hero-animate-5 flex flex-col items-center w-full md:w-auto" data-id="element-140">
          <button onClick={() => {
          const scrollToPricing = () => {
            const el = document.getElementById('pricing');
            if (el) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
              // Re-scroll after layout settles (content-visibility sections)
              setTimeout(() => {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }, 600);
            }
          };
          scrollToPricing();
        }} className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-bold text-sm md:text-lg py-3 px-6 md:py-4 md:px-10 rounded-full shadow-[0_0_25px_rgba(168,85,247,0.35)] transition-all transform hover:scale-[1.03] flex items-center justify-center gap-2 w-full md:w-auto border border-purple-400/30" data-id="element-141">
            👉 QUIERO EMPEZAR HOY — ANTES QUE SUBA EL PRECIO
          </button>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-5 mt-4 md:mt-5 text-[10px] md:text-sm text-slate-500" data-id="element-142">
            <span data-id="element-143">🛡️ Garantía 7 días sin preguntas</span>
            <span className="text-slate-700" data-id="element-144">•</span>
            <span data-id="element-145">🔒 Pago 100% seguro</span>
            <span className="text-slate-700" data-id="element-146">•</span>
            <span data-id="element-147">🌎 En tu moneda local</span>
          </div>
        </div>
      </div>
    </section>;
}